import { assign } from 'lodash';
import Cookies from 'universal-cookie';

const cookies = new Cookies();
const DEFAULT_COOKIE_OPTIONS = {
  path: '/',
  domain: '.dooray.com',
};
const DEFAULT_GET_DO_NOT_PARSE = false;

function get(key, doNotParse = DEFAULT_GET_DO_NOT_PARSE) {
  return cookies.get(key, doNotParse);
}

function set(key, val, option) {
  cookies.set(key, val, assign({}, DEFAULT_COOKIE_OPTIONS, option));
}

function remove(key, option) {
  cookies.remove(key, assign({}, DEFAULT_COOKIE_OPTIONS, option));
}

const chCookie = {
  get,
  set,
  remove,
};
export default chCookie;
